module.exports = __webpack_public_path__ + "img/关于我们背景.c0f0aa55.png";